import { Type } from 'class-transformer';
import { CreateOrderAsset } from './create-order-asset';

export class CreateOrder {
  purpose: string;

  name?: string;

  collectionId?: string;

  flow: string;

  unit: string;

  @Type(() => CreateOrderAsset)
  assets: CreateOrderAsset[];
}
